import { IconButton, OdinIconSize } from '@myosh/odin-components';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../record/record-menu.component';
import type { MenuComponentProps } from '../../record/record-menu.component';

interface SchedulerMenuProps {
  onDeleteScheduleConfirmationModalShow: () => void;
  isAdmin: boolean;
  canModify: boolean;
  fullScreen?: boolean;
}

const SchedulerMenu = ({
  onDeleteScheduleConfirmationModalShow,
  canModify,
  fullScreen = false,
}: SchedulerMenuProps) => {
  const { t } = useTranslation();

  const actionDropdownItemStyle = clsx({
    'text-sm flex items-center whitespace-nowrap px-2 py-1 leading-5 hover:bg-primary-4 cursor-pointer': !fullScreen,
  });

  const menuStyle = clsx({
    'z-30 absolute right-0 top-9 hidden w-48 flex-col bg-mono-1 py-1 shadow group-hover:flex': !fullScreen,
    flex: fullScreen,
  });

  const menus: MenuComponentProps[] = (
    [
      {
        title: t('delete'),
        className: actionDropdownItemStyle,
        onClick: onDeleteScheduleConfirmationModalShow,
        icon: 'Trash',
        hidden: !canModify,
      },
    ] satisfies MenuComponentProps[]
  ).filter((menu) => !menu.hidden);

  return menus.length > 0 ? (
    <div className="group relative">
      {!fullScreen && (
        <IconButton
          icon="Ellipsis"
          iconSize={OdinIconSize.Medium}
          classNames="mx-2 h-9 flex items-center group-hover:text-gray-1 "
          iconClassName={'w-6'}
        />
      )}
      <div className={menuStyle}>
        {menus.map((menu) => {
          return <MenuItem key={menu.title} menu={menu} fullScreenMode={fullScreen} />;
        })}
      </div>
    </div>
  ) : undefined;
};

export default SchedulerMenu;
